// extracted by mini-css-extract-plugin
export default {"root":"DataSourcesItem_root__SNhNf","icon":"DataSourcesItem_icon__VEtey","title":"DataSourcesItem_title__WkrI5","mark":"DataSourcesItem_mark__9fgVZ"};